import {
  ISpecification,
  ISpecificationGroup,
  SpecificationTypes,
} from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import NextImage from "@/app/components/lib/NextImage";
import { safeHTML } from "@/utils/functions/safeHTML";
import { Fragment } from "react";

interface Props {
  spec: ISpecificationGroup[];
}

const Attribute = ({ spec }: { spec: ISpecification }) => {
  const { key: name, value, type } = spec;
  switch (type) {
    case SpecificationTypes.text:
      return (
        <>
          <td>{name}</td>
          <td>{value}</td>
        </>
      );
    case SpecificationTypes.image:
      return (
        <>
          <td>{name}</td>
          <td>
            <div className="product-image" style={{ width: 48, height: 48 }}>
              <NextImage alt={name} src={value} objectFit="fill" />
            </div>
          </td>
        </>
      );
    case SpecificationTypes.color:
      return (
        <>
          <td>{name}</td>
          <td>
            <div
              style={{
                background: value,
                width: 32,
                height: 32,
                borderRadius: "50%",
                border: "1px solid #C4C4C4",
              }}
            />
          </td>
        </>
      );
    case SpecificationTypes.editor:
      return (
        <>
          <td>{name}</td>
          <td>
            <div dangerouslySetInnerHTML={{ __html: safeHTML(value) }} />
          </td>
        </>
      );
    default:
      return null;
  }
};
const ProdSpec: React.FC<Props> = ({ spec }) => {
  return (
    <div className="specifications-table-wrapper">
      <table>
        <tbody>
          {spec?.map((spec, key) => (
            <Fragment key={key}>
              <tr>
                <td colSpan={2} className="group-header">
                  {spec.title}
                </td>
              </tr>
              {spec.data.map(
                (s, key) =>
                  s.type !== SpecificationTypes.image && (
                    <tr key={key}>
                      <Attribute spec={s} />
                    </tr>
                  )
              )}
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProdSpec;
